import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { appConfig } from './../app.config';
import * as Player from "@vimeo/player/dist/player.js";
import { map, concat, forEach, filter, flatten, findIndex } from 'lodash';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import * as imagesLoaded from 'imagesloaded';

@Component({
  selector: 'app-content-blocks',
  templateUrl: './content-blocks.component.html',
  styleUrls: ['./content-blocks.component.scss'],
  animations: [
    trigger('fadeIn', [
      state('hidden', style({
        opacity: '0',
        visibility: 'hidden'
      })),
      state('visible',   style({
        opacity: '1',
        visibility: 'visible'
      })),
      transition('hidden => visible', animate('250ms ease-in'))
    ])
  ]
})
export class ContentBlocksComponent implements OnInit {
  @Input() rows: any;
  @Input() hasGallery: boolean = false;

  @Output() imageClick = new EventEmitter();
  @Output() isContentLoaded = new EventEmitter();

  @ViewChildren('vimeo') public vimeoElRef: QueryList<ElementRef>;
  
  public imageSrcBase = appConfig.imageUrl;
  public isLoaded = false;

  _rows: any[];
  screenRes: string = this.isHiResScreen() ? 'hiRes' : 'normal';

  constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private elRef: ElementRef
  ) { }

  ngOnInit() {
    let videoCount = 0;
    this._rows = map(this.rows, (row: any) => {
      let _row = [];
      if (row.cols === 1) {
        _row = row.single_content;
      } else {
        let left = typeof row.left_content !== 'undefined' ? row.left_content : {
          content_type: 'blank'
        };
        let right = typeof row.right_content !== 'undefined' ? row.right_content : {
          content_type: 'blank'
        };
        _row = concat(left, right);
      }
      forEach(_row, (block) => {
        if (block.content_type === 'content_soundCloud') {
          block.src = this.getSoundcloudUrlFromId(block.soundcloud_id);
        } else if (block.content_type === 'content_video') {
          this.loadVideo(block.video_url, videoCount);
          videoCount++;
        }
      });
      return _row;
    });

    imagesLoaded(this.elRef, ( instance ) => {
      setTimeout(() => {
        this.isLoaded = true;
        this.isContentLoaded.emit();
      }, 1000);
    });
  }

  loadVideo(url, videoIndex) {
    var options = {
      url: url,
      width: 1280
    };
    setTimeout(() => {
      if (typeof this.vimeoElRef !== 'undefined' && this.vimeoElRef.toArray().length >= videoIndex + 1) {
        new Player(this.vimeoElRef.toArray()[videoIndex].nativeElement, options);
      }
    });
  }

  getImageIndex(block) {
    let imageBlocks = filter(this.rows, {single_content_type: 'content_images'});
    let imageContent = flatten(map(imageBlocks, 'single_content'));
    return findIndex(imageContent, { image_id: block.id });
  }

  trackItem(index, item) {
    return item ? item.id : undefined;
  }

  onImageClick(block, $event) {
    $event.preventDefault();

    let newPath = this.getUrl(block);
    let imageParameter = this.getImageParameter(block);
    this.location.go(newPath);
    this.imageClick.emit(imageParameter);
  }

  getImageParameter(block) {
    let imageParameter;

    if (this.hasGallery) {
      imageParameter = this.getImageIndex(block);
    } else if (block.large) {
      imageParameter = block.id;
    }

    return imageParameter;
  }

  getUrl(block) {
    let currentPath = this.location.path()
    let imageParameter = this.getImageParameter(block);
    let newPath;
    let overlayPath;

    if (this.hasGallery) {
      overlayPath = `/gallery/${(imageParameter + 1)}`;
    } else if (block.large) {
      overlayPath = `/image/${imageParameter}`;
    }

    if (/(\?.*)/.test(currentPath)) {
      newPath = currentPath.replace(/(\?.*)/, `${overlayPath}$1`)
    } else {
      newPath = currentPath + overlayPath;
    }

    return newPath;
  }

  getSoundcloudUrlFromId(id) {
    let url = 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/' + id + '&amp;color=000000&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false';
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  isHiResScreen() {
    // starts with default value for modern browsers
    var dpr = window.devicePixelRatio ||

    // fallback for IE
        (window.screen.deviceXDPI / window.screen.logicalXDPI) ||

    // default value
        1;

    return !!(dpr > 1);
  }
}



// WEBPACK FOOTER //
// ./src/app/content-blocks/content-blocks.component.ts